import * as React from 'react';

import { Shape2Tone } from '../../../components/Shape2/Shape2';
import { Bem } from '../../../service/Bem/Bem';
import { CanvasPcodeVideoFrameParams } from '../../../service/Pcode/PcodeCanvasVideo';
import { ValidationErrorData } from '../../../typings/common';
import { CreativeOptionsData } from '../../CreativeOptions/typings';
import { PcodeVideoCanvasPreview } from '../../PcodeVideoCanvasPreview/PcodeVideoCanvasPreview';
import { AddCreativePage } from '../AddCreativePage';

import './AddOverlayCreative.css';

export interface AddOverlayCreativeProps {
    videoPreviewData?: Partial<CanvasPcodeVideoFrameParams>;

    submitEnabled?: boolean;
    isLoading: boolean;
    isSaving: boolean;
    isPreviewLoading?: boolean;

    creativeOptions?: CreativeOptionsData;
    onSaveName: (name: string) => void;
    onOptionChange: (groupName: string, name: string, value: string) => void;
    onGroupVisibleChange: (groupName: string) => void;

    initVideoData: () => void;
    onSave: () => void;
    onCancel: () => void;
    error?: ValidationErrorData;
}

const BLOCK = 'add-overlay-creative';

export class AddOverlayCreative extends React.PureComponent<AddOverlayCreativeProps> {
    private previewVideoRef: React.RefObject<PcodeVideoCanvasPreview> = React.createRef();

    componentDidMount(): void {
        this.props.initVideoData();
    }

    componentDidUpdate(prevProps: Readonly<AddOverlayCreativeProps>): void {
        const { isPreviewLoading } = this.props;
        if (prevProps.isPreviewLoading !== isPreviewLoading && this.previewVideoRef.current) {
            this.previewVideoRef.current.onExternalToggleLoadingStatus({
                isLoading: Boolean(isPreviewLoading)
            });
        }
    }

    render(): React.ReactNode {
        const {
            creativeOptions,
            submitEnabled,
            onSaveName,
            onOptionChange,
            onGroupVisibleChange,
            onSave,
            onCancel,
            isLoading,
            isSaving,
            error
        } = this.props;

        return (
            <AddCreativePage
                isDocCenterTooltip={true}
                creativeOptions={creativeOptions}
                onSaveName={onSaveName}
                onOptionChange={onOptionChange}
                onGroupVisibleChange={onGroupVisibleChange}
                preview={this.renderPreview()}
                titleCls={Bem.cls(BLOCK, 'preview-title')}
                optionsCls={Bem.cls(BLOCK, 'options')}
                iconsTone={Shape2Tone.white}
                onSave={onSave}
                onCancel={onCancel}
                isLoading={isLoading}
                isSaving={isSaving}
                error={error}
                submitEnabled={submitEnabled}
            />
        );
    }

    private renderPreview = (): React.ReactNode => {
        return <div className={Bem.cls(BLOCK, 'preview-container')} />;
    };
}
